'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosPint = function IoIosPint(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.5 13.3c0 7.6-2.5 7.9-2.5 14.1 0 3.1 1.3 5.6 1.3 7.8 0 2.1-0.8 2.3-2.5 2.3h-10c-1.8 0-2.5-0.2-2.5-2.3 0-2.2 1.2-4.7 1.2-7.8 0-6.2-2.5-6.5-2.5-14.1 0-1.7 0.1-7 1.5-9.8 0.3-0.7 1-1 2.5-1h9.5c1.5 0 2.2 0.3 2.5 1 1.4 2.8 1.5 8.1 1.5 9.8z m-14.8-9.2c-0.7 1.2-1.1 3.3-1.4 5.9h14.9c-0.3-2.6-0.7-4.7-1.4-5.9 0-0.2 0-0.1-0.1-0.2-0.2-0.1-0.5-0.1-1.2-0.1h-9.5c-0.7 0-1 0-1.2 0.1-0.1 0.1-0.1 0-0.1 0.2z' })
        )
    );
};

exports.default = IoIosPint;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-pint.js
// module id = 2246
// module chunks = 0